import React from "react";
import {
  TouchableOpacity,
  Image,
  View,
  ActivityIndicator,
  StyleProp,
  ViewStyle,
  ImageProps,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { useAHImage } from "./useAHImage";

export type AHImageProps = {
  url: string;
  onPress?: () => void;
  isUploading?: boolean;
  style?: StyleProp<ViewStyle>;
} & Omit<ImageProps, "source">;

export const AHImage = ({
  url,
  onPress,
  style,
  onError,
  onLoad,
  onLoadStart,
  isUploading,
  ...imageProps
}: AHImageProps) => {
  const {
    imageProps: _imageProps,
    isLoading,
    error,
  } = useAHImage({ onError, onLoad, onLoadStart });

  return (
    <TouchableOpacity onPress={onPress} style={[{ flex: 1 }, style]}>
      <Image
        style={{
          flex: 1,
        }}
        resizeMethod="scale"
        resizeMode="cover"
        source={{ uri: url, cache: "force-cache" }}
        {..._imageProps}
        {...imageProps}
      />
      {isLoading || error || isUploading ? (
        <AHImageStatusOverlay error={!!error} />
      ) : null}
    </TouchableOpacity>
  );
};

export function AHImageStatusOverlay({ error }: { error: boolean }) {
  return (
    <View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: "rgba(0,0,0,0.3)",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      {error ? (
        <Feather
          color="#FFF"
          size={20}
          style={{ alignSelf: "center" }}
          name="image"
        />
      ) : (
        <ActivityIndicator color="#FFF" />
      )}
    </View>
  );
}
